import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import NewKaryawan from "../../components/NewKaryawan";
import Grid from '@mui/material/Grid';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import React, {Component} from 'react';
import axios from "axios";
import { useEffect, useState, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import NumberFormat from 'react-number-format';
import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhoneInput from 'react-phone-number-input';
import CheckIcon from "@mui/icons-material/Check";
import "./style.css";
import {useNavigate} from "react-router-dom";
import { useLocation} from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import BusinessIcon from '@mui/icons-material/Business';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function EditCompany(){
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [names,setNames] = useState(["Perdagangan", "Transportasi", "Pertambangan", "Teknologi", "E-Commerce", "Keuangan", "Tour/Travel", "Skin Care", "F&B"]);
    const [produk,setProduk] = useState(["Virtual Office", "Private Office", "Meeting Room Kecil", "Meeting Room Besar (Event Room)", "Pendirian PT", "Pendirian CV", "Izin Khusus", "PKP", "Pajak", "Akutansi", "Website", "Merek"]);
    const [lokasi,setLokasi] = useState(["Jakarta Selatan", "Jakarta Barat", "Jakarta Pusat", "Jakarta Utara", "Jakarta Timur", "Tangerang", "Bekasi", "Bali", "Surabaya", "Depok", "Kalimantan"]);
    const [sales, setSales]= useState(["Adnan", "Diva", "Felly", "Reinner"])
    const [isEnd,setIsEnd] = useState("loading..")
    const [searchThis, setsearchThis]= useState("Phone");
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const passed = useLocation();
    const [contractData, setContractData] = useState(passed.state.post);  // Added this line
    const [showData, setShowData] = useState(passed.state.post);  // Added this line
    const press = () => {
        console.log(passed)
    }
    //FollowUp History
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }
    useEffect(() => {
        fetchPosts();
        console.log(posts)
    }, [skip,query]);
    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data.data)

                    if(data.data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }


                    const yoyo = data.data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,query);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }

            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    //Edit Inquiry Start
    const [isEditable, setIsEditable] = useState({});
    const [error,setError] = useState();

    const handleEditClick = (field) => {
        setNIBFile(null);
setNIBFileName("");
setUploadedNIBStat(false);
        setAKTEFile(null);
setAKTEFileName("");
setUploadedAKTEStat(false);
        setNPWPFile(null);
    setNPWPFileName("");
    setUploadedNPWPStat(false);
        setContractData(showData)
        setError("")
      setIsEditable(prevState => {
        const newState = { ...prevState }; // copy all fields
        for (let key in newState) {
          if (key !== field) newState[key] = false; // if it's not the field we're toggling, set it to false
        }
        newState[field] = !prevState[field]; // toggle the field we're interested in
        return newState;
      });
    }
    const DownloadDoc = (event) => {
        let post;
        if(event === "NPWP"){
             post = showData.npwpKey
        }
        if(event === "AKTE"){
             post = showData.akteKey
        }

        if(event === "NIB"){
             post = showData.nibKey
        }
        console.log("here")
        if(post){
            console.log("here22")

            if (Array.isArray(post)) {
                post.forEach(filename => {
                console.log(filename)
                  axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                      responseType: 'blob' // Tell axios to get the response as a blob
                  })
                  .then((response) => {
                    const contentType = response.headers['content-type'];
                    console.log(response);
                    console.log(response.headers)
                    console.log(contentType)
                    if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                      // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                      const blob = new Blob([response.data], { type: contentType });
                      const url = URL.createObjectURL(blob);
                      window.open(url);
                  } else {
                      // For other file types, download the file
                      const link = document.createElement('a');
                      link.href = window.URL.createObjectURL(new Blob([response.data]));
                      link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                      document.body.appendChild(link);
                      link.click();
                  }
                  })
                  .catch((error) => {
                      console.log('Error fetching the file:', error);
                  });
              });
          } else {
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${post}`, {
              responseType: 'blob' // Tell axios to get the response as a blob
          })
          .then((response) => {
            const contentType = response.headers['content-type'];
            console.log(response);
            console.log(response.headers)
            console.log(contentType)
            if (['image/png', 'image/jpeg', 'image/gif','image/webp', 'image/jpg' , 'application/pdf'].includes(contentType)) {
              // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
              const blob = new Blob([response.data], { type: contentType });
              const url = URL.createObjectURL(blob);
              window.open(url);
          } else {
              // For other file types, download the file
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(new Blob([response.data]));
              link.setAttribute('download', 'file'); // Modify the filename and extension as needed
              document.body.appendChild(link);
              link.click();
          }
          })
          .catch((error) => {
              console.log('Error fetching the file:', error);
          });
          }
          }
    }
    ///end download
    const setPhoneNumber = (event) => {
        console.log(event)
        setContractData({...contractData, Phone: event});  // Changed this line  
    }
    const handleNamaPerusahaanEdit = (event) => {
        setContractData({...contractData, namaPerusahaan: event.target.value});  // Changed this line  
    }
    const handleNPWP = (event) => {
        let value = event.target.value;
  value = value.replace(/\D/g, ""); // Remove any non digit character
  value = value.replace(/^(\d{2})(\d)/, "$1.$2");
  value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
  value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  value = value.replace(/^(\d{2})\.(\d{3})\.(\d{3})-(\d{1})(\d)/, "$1.$2.$3-$4.$5");
  value = value.slice(0,20); // Limit length to 15 digits and 5 special characters (20 in total)
        setContractData({...contractData, npwpPerusahaan: value});  // Changed this line  
      };

    const setAkte = (event) => {
        setContractData({...contractData, akte: event.target.value});  // Changed this line  
    }
    const setNIB = (event) => {
        setContractData({...contractData, noNib: event.target.value});  // Changed this line  
    }

    const selectTipePerusahaan = (event) => {
        setContractData({...contractData, tipePerusahaan: event.target.value})
    }

    const setSelectedIndustri = (event) => {
        setContractData({...contractData, industri: event});  // Changed this line  
    }

    const setSelectedLokasi = (event) => {
        setContractData({...contractData, LokasiInterest: event});  // Changed this line  
    }

    const setSelectedSales = (event) => {
        setContractData({...contractData, Sales: event});  // Changed this line  
    }
    const UpdateInq = () => {
        if(contractData.namaPerusahaan && contractData.industri && contractData.npwpPerusahaan){
            
             // Assuming that fileKTP and fileNPWP are your file objects
            const filesToUpload = [
            { file: fileNIB, name: 'fileNIB' },
            { file: fileNPWP, name: 'fileNPWP' },
            { file: fileAKTE, name: 'fileAkte' },
          ];
  
          // Map over the files array and return an array of promises
          const uploadPromises = filesToUpload.map((fileObj) => {
            if (fileObj.file) { // if the file is not null, upload it
              return axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL`, {
                params: {
                  filename: fileObj.name // send the filename to the server
                }
              })
              .then(response => {
                const uploadUrl = response.data.url;
                const key = response.data.key; // Get the key from the response
  
                return fetch(uploadUrl, {
                  method: 'PUT',
                  headers: {
                    'Content-Type': fileObj.file.type
                  },
                  body: fileObj.file
                }).then(() => key); // After the file is uploaded, return the key
              })
              .catch(error => {
                console.error('Error during file upload:', error.response.data.message);
              });
            }
  
            // if the file is null, return a resolved promise with value null
            return Promise.resolve(null);
          });
            
            
          Promise.all(uploadPromises)
          .then(fileKeys => {
            const [nibKey, npwpKey, akteKey] = fileKeys; // Extract keys from the resolved values array
            if(fileNPWP !== null){
                setContractData({...contractData, npwpKey: npwpKey});  // Changed this line  
            }
            if(fileNIB !== null){
                setContractData({...contractData, nibKey: nibKey});  // Changed this line  
            }
            if(fileAKTE !== null){
                setContractData({...contractData, nibKey: nibKey});  // Changed this line  
            }
            axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateComp`, {
                contractData, npwpKey, nibKey, akteKey
            }).then(response => {
                handleEditClick('editInquiry')
                setShowData(contractData)
        }).catch(error => {
            setError(`Error: ${error.response.data.message}`);  // Here you can set the error message you need
        })})

        }else{
            setError("Ada data yang belum kamu isi")
        }
    }

    //Edit Inquiry End

    //NPWP File Upload Starts Here
    const [uploadedNPWPStat, setUploadedNPWPStat] = useState(false);
    const [fileNPWP, setNPWPFile] = useState(null);
    const [npwpfileName, setNPWPFileName] = useState("");
  const handleNPWPFileChange = (event) => {
    setNPWPFile(event.target.files[0]);
    setNPWPFileName(event.target.files[0].name);
    setUploadedNPWPStat(true);
  };

  const clearnpwpFile = (event)=>{
    setNPWPFile(null);
    setNPWPFileName("");
    setUploadedNPWPStat(false);
  }

  const handleNPWPUploadButtonClick = () => {
    fileInput.current.click();
  };
  const fileInput = useRef(null);
//NPWP File Upload Ends Here
//NIB File Upload Starts Here
const [uploadedNIBStat, setUploadedNIBStat] = useState(false);
const [fileNIB, setNIBFile] = useState(null);
const [nibfileName, setNIBFileName] = useState("");
const handleNIBFileChange = (event) => {
setNIBFile(event.target.files[0]);
setNIBFileName(event.target.files[0].name);
setUploadedNIBStat(true);
};

const clearnibFile = (event)=>{
setNIBFile(null);
setNIBFileName("");
setUploadedNIBStat(false);
}

const handleNIBUploadButtonClick = () => {
fileInputNIB.current.click();
};
const fileInputNIB = useRef(null);
//NIB File Upload Ends Here
//AKRE File Upload Starts Here
const [uploadedAKTEStat, setUploadedAKTEStat] = useState(false);
const [fileAKTE, setAKTEFile] = useState(null);
const [AKTEfileName, setAKTEFileName] = useState("");
const handleAKTEFileChange = (event) => {
setAKTEFile(event.target.files[0]);
setAKTEFileName(event.target.files[0].name);
setUploadedAKTEStat(true);
};

const clearAKTEFile = (event)=>{
setAKTEFile(null);
setAKTEFileName("");
setUploadedAKTEStat(false);
}

const handleAKTEUploadButtonClick = () => {
fileInputAKTE.current.click();
};
const fileInputAKTE = useRef(null);
//AKTE File Upload Ends Here
//New Karyawan Starts Here
const [openNewKaryawan,setOpenNewKaryawan] = useState(false)
const closeOpenNewKaryawan = () => {
    setOpenNewKaryawan(false)
}

const openOpenNewKaryawan = () => {
    setOpenNewKaryawan(true)
}

//New Karyawan Ends Here
    return <Grid container>
    <Dialog open={openNewKaryawan} onClose={closeOpenNewKaryawan}>
        <NewKaryawan closeOpenNewKaryawan={closeOpenNewKaryawan} showData={showData}></NewKaryawan>
    </Dialog>
    <Grid item xl={0.5} lg={0.5} md={0.5} sm={3.2} className="leftmenucolor">
        <LeftMenu/>
    </Grid>
    <Grid item xl={11.5} lg={11.5} md={11.5} sm={8.8}>
        <Grid className="boxshadowclass">
            <Header judul="Company Profile" isi="Detail Perusahaan"></Header>
        </Grid>
        <Grid sx={{p:5}}>
            <Grid container>
                <Grid container direction="column" justifyContent="center" alignItems="center" xs={3}>
                    <Grid item>
                        <BusinessIcon sx={{ width: 100, height: 100 }}></BusinessIcon>
                    </Grid>
                </Grid>


                <Grid xs={9}>
                    <Grid container  sx={{mt:3}}>
                        <Typography><b>Nama Perusahaan:</b> {isEditable.editInquiry ? <><Select  fullWidth value={contractData.tipePerusahaan} onChange={event => selectTipePerusahaan(event)}><MenuItem value="PT">PT.</MenuItem><MenuItem value="CV">CV.</MenuItem><MenuItem value="Yayasan">Yayasan</MenuItem><MenuItem value="Koperasi">Koperasi</MenuItem><MenuItem value="Law Firm">Law Firm</MenuItem></Select>
 <TextField onChange={(event)=>handleNamaPerusahaanEdit(event)} value={contractData.namaPerusahaan}></TextField></>
                        : (showData.tipePerusahaan?? "") +" "+ showData.namaPerusahaan}</Typography>
                    </Grid>
                    <Grid container  sx={{mt:3}}>
                        <Typography><b>Industri:</b> {isEditable.editInquiry ?  <Autocomplete
                                  sx={{ width: 360, mt:2 }}
                                  multiple
                                  options={names}
                                  freeSolo
                                  getOptionLabel={(option) => option}
                                  disableCloseOnSelect
                                  value={contractData.industri}
                                  onChange={(event, newValue) => {
                                    setSelectedIndustri(newValue);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      label="Pilih Iklan"
                                      placeholder="Pilih Iklan"
                                    />
                                  )}
                                  renderOption={(props, option, { selected }) => (
                                    <MenuItem
                                      {...props}
                                      key={option}
                                      value={option}
                                      sx={{ justifyContent: "space-between" }}
                                    >
                                      {option}
                                      {selected ? <CheckIcon color="info" /> : null}
                                    </MenuItem>
                                  )}
                                />
                        : showData.industri.join(', ')}</Typography>
                    </Grid>
                    <Grid container  sx={{mt:3}}>
                        <Typography><b>NPWP:</b> {isEditable.editInquiry ? <Grid container>
                        
                        <Grid sx={{mr:2}}>
                            <TextField onChange={(event)=>handleNPWP(event)} value={contractData.npwpPerusahaan}></TextField>
                        </Grid>
                        <Grid>
                            
                        </Grid>
                            <input
                                type="file"
                                ref={fileInput}
                                onChange={handleNPWPFileChange}
                                style={{ display: 'none' }}
                            />
                            <Button
                                color={uploadedNPWPStat ? "success" : "primary"}
                                variant="contained"
                                onClick={handleNPWPUploadButtonClick}
                                style={{ marginRight: '8px' }}
                            >
                                Upload NPWP Baru
                            </Button>
                            <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {npwpfileName.length > 20 ? `${npwpfileName.slice(0, 17)}...` : npwpfileName}
                            </Typography>
                            {uploadedNPWPStat && (
                                <IconButton size="small" onClick={clearnpwpFile}>
                                <CloseIcon />
                                </IconButton>
                            )}
                            </Grid>
                        : showData.npwpPerusahaan? (<>{showData.npwpPerusahaan} <Button onClick={()=>DownloadDoc("NPWP")}>Download NPWP</Button></>) : (<span style={{ color: 'grey', fontStyle: 'italic' }}>Belum ada data</span>)}</Typography>
                    </Grid>
                    <Grid container  sx={{mt:3}}>
                        <Typography><b>Akte Perusahaan:</b> {isEditable.editInquiry ? <Grid container>
                        
                        <Grid sx={{mr:2}}>
                            <TextField onChange={(event)=> setAkte(event)} value={contractData.akte}></TextField>
                        </Grid>
                        <Grid>
                            
                        </Grid>
                            <input
                                type="file"
                                ref={fileInputAKTE}
                                onChange={handleAKTEFileChange}
                                style={{ display: 'none' }}
                            />
                            <Button
                                color={uploadedAKTEStat ? "success" : "primary"}
                                variant="contained"
                                onClick={handleAKTEUploadButtonClick}
                                style={{ marginRight: '8px' }}
                            >
                                Upload Akte Baru
                            </Button>
                            <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {AKTEfileName.length > 20 ? `${AKTEfileName.slice(0, 17)}...` : AKTEfileName}
                            </Typography>
                            {uploadedAKTEStat && (
                                <IconButton size="small" onClick={clearAKTEFile}>
                                <CloseIcon />
                                </IconButton>
                            )}
                            </Grid>
                        : showData.akte? (<>{showData.akte} <Button onClick={()=>DownloadDoc("AKTE")}>Download Akte</Button></>) : (<span style={{ color: 'grey', fontStyle: 'italic' }}>Belum ada data</span>)}</Typography>
                    </Grid>
                    <Grid container  sx={{mt:3}}>
                        <Typography><b>NIB Perusahaan:</b> {isEditable.editInquiry ? <Grid container>
                        
                        <Grid sx={{mr:2}}>
                            <TextField onChange={(event)=> setNIB(event)} value={contractData.noNib}></TextField>
                        </Grid>
                        <Grid>
                            
                        </Grid>
                            <input
                            type="file"
                            ref={fileInputNIB}
                            onChange={handleNIBFileChange}
                            style={{ display: 'none' }}
                        />
                        <Button
                            color={uploadedNIBStat ? "success" : "primary"}
                            variant="contained"
                            onClick={handleNIBUploadButtonClick}
                            style={{ marginRight: '8px' }}
                        >
                            Upload NIB/SIUP Baru
                        </Button>
                        <Typography variant="body1" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {nibfileName.length > 20 ? `${nibfileName.slice(0, 17)}...` : nibfileName}
                        </Typography>
                        {uploadedNIBStat && (
                            <IconButton size="small" onClick={clearnibFile}>
                            <CloseIcon />
                            </IconButton>
                        )}
                            </Grid>
                        : showData.noNib? (<>{showData.noNib} <Button onClick={()=>DownloadDoc("NIB")}>Download NIB</Button></>) : (<span style={{ color: 'grey', fontStyle: 'italic' }}>Belum ada data</span>)}</Typography>
                    </Grid>
                </Grid>
                
            </Grid>
            <Grid container justifyContent="flex-end" sx={{mt:5}}>
                        {isEditable.editInquiry ? <Grid container justifyContent="flex-end">
                            <Button sx={{m:1}} variant="contained" color="error" onClick={() => handleEditClick('editInquiry')}>Batal</Button>
                            <Button sx={{m:1}} variant="contained" color="success" onClick={()=>UpdateInq()}>Simpan</Button>
                        </Grid>
                        :<IconButton onClick={() => handleEditClick('editInquiry')}><EditIcon sx={{ fontSize: 24 }} color="primary"/></IconButton>}
            </Grid>

            {error && <Grid className="error_text" sx={{mb:3}}>{error}</Grid>}

            <Divider variant="inset" sx={{ mb:5, height:2, bgcolor: 'black'}} />
            <Grid container sx={{mt:5}} direction="column" justifyContent="center" alignItems="center">
                            <Grid container xs={9.6} sx={{mt:5}} direction="column" justifyContent="center" alignItems="center">
                                <Typography align="center" ><b>List Karyawan</b></Typography>
                            </Grid>
                            <Grid container xs={9.6} sx={{mb:5}} direction="column" justifyContent="center" alignItems="center">
                                <Button align="center" variant="contian" color="success" onClick={openOpenNewKaryawan}>Tambah Karyawan +</Button>
                            </Grid>
                            <Paper sx={{ width: '80%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 300, minHeight: 240 }} className="min-h-screen h-screen overflow-scroll">
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Nama
                                                </TableCell>
                                                <TableCell>
                                                    NPWP/KTP
                                                </TableCell>
                                                <TableCell>
                                                    Nomor Telepon
                                                </TableCell>
                                                <TableCell>
                                                    Email
                                                </TableCell>
                                                <TableCell>
                                                    Posisi
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {showData.employees?.map((post) => (
                                            <TableBody>
                                                <TableRow hover >
                                                    <TableCell style={{cursor:'pointer'}}>
                                                        <p>{post.Nama}</p>
                                                    </TableCell>
                                                    <TableCell style={{cursor:'pointer'}}>
                                                        <p>{post.KTP?? post.NPWP?? ""}</p>
                                                    </TableCell>
                                                    <TableCell style={{cursor:'pointer'}}>
                                                        <p>{post.Phone}</p>
                                                    </TableCell>
                                                    <TableCell style={{cursor:'pointer'}}>
                                                        <p>{post.Email[0]}</p>
                                                    </TableCell>
                                                    <TableCell style={{cursor:'pointer'}}>
                                                    {(() => {
                                                        let companiesArray = Array.isArray(post.Companies) ? post.Companies : [post.Companies];
                                                        let company = companiesArray.find(company => company.CompanyID === showData._id);
                                                        return <p>{company?.posisi?.filter(item => item).join(", ")}</p>
                                                    })()}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        Selesai...
                                    </Table>
                                </TableContainer>
                            </Paper>
            </Grid>
        </Grid>
        

    </Grid>
</Grid>
}